import React from "react";
import { useForm } from "react-hook-form";
import { Icons } from "../../../utils/Icons";
import { Tooltip, TextField } from "@mui/material";
import { toCamelCase } from "../../../utils/Helper";

const MessageContainer = ({ setIsSetting, data, title, onSubmit }: any) => {
  const { register, setValue, watch } = useForm({
    defaultValues: {
      status: data?.status || "pending",
      response: "",
    },
  });

  const handleStatusChange = (newStatus: string) => {
    setValue("status", newStatus); // Update the status in the form
    const payload = {
      id: data?.id,
      body: {
        status: newStatus,
        response: watch("response"), // Get the latest reason value
      },
    };
    onSubmit(payload);
  };

  return (
    <>
      <div className="customizer-body right-panel-body">
        <div className="d-flex align-items-center justify-content-between">
          <div className="mt-2">
            <h6>
              <Tooltip title={title} placement="top" arrow>
                <h5>{title}</h5>
              </Tooltip>
              {/* <span>{data?.title}</span> */}
            </h6>
          </div>
          <div className="d-flex align-items-center gap-3">
            <span onClick={() => setIsSetting(false)}>{Icons?.close}</span>
          </div>
        </div>

        <div className="message-detail-data">
          {data?.subject && (
            <div className="row flex-column align-items-start">
              <div className="col-md-12 d-flex p-3 pb-2 message-detail-heading border-bottom">
                <h4 className="mb-0">Subject</h4>
              </div>
              {data?.subject && (
                <div className="col-md-12 message-body">{data?.subject}</div>
              )}
            </div>
          )}
          {data?.message && (
            <div className="row flex-column align-items-start">
              <div className="col-md-12 d-flex p-3 pb-2 message-detail-heading border-bottom">
                <h4 className="mb-0">Message</h4>
              </div>
              {data?.message && (
                <div className="col-md-12 message-body">{data?.message}</div>
              )}
            </div>
          )}
        </div>

        {/* Response Section */}
        <div className="response-box mt-4">
          <div className="col-md-12 d-flex p-1 pb-2 message-detail-heading border-bottom">
            <h4 className="mb-0">Message</h4>
          </div>
          <TextField
            {...register("response")}
            // label="Reason"
            placeholder="Enter your reason for status change"
            multiline
            rows={4}
            fullWidth
          />
        </div>

        {/* Status Change Section */}
        <div className="response-box mt-4">
          <div className="row mx-4" style={{ justifyContent: "flex-end" }}>
            <div className="col-md-4 btn-group">
              <button
                type="button"
                className={`btn status dropdown-toggle ${
                  data?.status === "pending"
                    ? "btn-outline-danger"
                    : data?.status === "active"
                    ? "btn-outline-warning "
                    : "btn-outline-success "
                }`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ color: "#fff", backgroundColor: "#CC0000" }}
              >
                {toCamelCase(data?.status)}
              </button>
              <ul className="dropdown-menu">
                {data?.status === "pending" && (
                  <>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleStatusChange("active")}
                      >
                        Active
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleStatusChange("resolved")}
                      >
                        Resolved
                      </button>
                    </li>
                  </>
                )}

                {data?.status === "active" && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleStatusChange("resolved")}
                    >
                      Resolved
                    </button>
                  </li>
                )}

                {data?.status === "resolved" && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleStatusChange("resolved")}
                    >
                      Resolved
                    </button>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageContainer;
